module.exports = __webpack_public_path__ + "img/hot.b4d89fbb.gif";